import {
    WebsiteStructure,
    Section,
    SectionType,
    HeroSection,
    AboutSection,
    MediaSection,
    ContactSection,
    TestimonialsSection,
    LatestUpdateSection,
    CatalogSection,
} from '../../../api/models';
import {WebsiteAboutSection} from '../sections/WebsiteAboutSection';
import {WebsiteCatalogSection} from '../sections/WebsiteCatalogSection';
import {WebsiteContactSection} from '../sections/WebsiteContactSection';
import {WebsiteHomeSection} from '../sections/WebsiteHomeSection';
import {WebsiteLatestUpdateSection} from '../sections/WebsiteLatestUpdateSection';
import {WebsiteMediaSection} from '../sections/WebsiteMediaSection';
import {WebsiteTestimonialsSection} from '../sections/WebsiteTestimonialsSection';

export const LayoutBuilder = (props: {data: WebsiteStructure}) => {
    const elements = props.data.sections.map((section: Section, index: number) => {
        switch (section.sectionType) {
            case SectionType.HERO:
                return <WebsiteHomeSection index={index} key={index} data={section as HeroSection} />;
            case SectionType.ABOUT:
                return <WebsiteAboutSection index={index} key={index} data={section as AboutSection} />;
            case SectionType.MEDIA:
                return <WebsiteMediaSection index={index} key={index} data={section as MediaSection} />;
            case SectionType.CONTACT:
                return <WebsiteContactSection index={index} key={index} data={section as ContactSection} />;
            case SectionType.TESTIMONIALS:
                return <WebsiteTestimonialsSection index={index} key={index} data={section as TestimonialsSection} />;
            case SectionType.LATEST_UPDATE:
                return <WebsiteLatestUpdateSection index={index} key={index} data={section as LatestUpdateSection} />;
            case SectionType.CATALOG:
                return <WebsiteCatalogSection index={index} key={index} data={section as CatalogSection} />;
        }
    });

    return <>{elements}</>;
};
